import API from "../configs/axiosInstance";

const getCustomerAccounts = () => {
    return API({
        url: `/account-service/v1/admins/account`,
        method: 'GET',
    });
};

const updatePasswordDisplaySetting = (accountId, showEmailLeakagePasswords) => {
    return API({
        url: `/account-service/v1/admins/${accountId}/leakage-password-display-setting`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: showEmailLeakagePasswords  
    });
};

const getAllAccountSettings = () => {
    return API({
        url: `/account-service/v1/admins/account-settings`,
        method: 'GET',
    });
};

const updateAccountLicense = (accountId, data) => {
    return API({
        url: `/account-service/v1/admins/${accountId}/license`,
        method: 'PUT',
        data
    });
};

const softDeleteAccount = (accountId) => {
    return API({
        url: `/account-service/v1/accounts/${accountId}`,
        method: 'DELETE',
    });
};

const deleteUserInDepartment = (data) => {
    return API({
        url: `/account-service/v1/admins/${data}/user`,
        method: 'DELETE',
    });
};

const getDemoRequests = () => {
    return API({
        url: `/account-service/v1/admins/demo-request`,
        method: 'GET',
    });
};

const getAssetCount = () => {
    return API({
        url: `/account-service/v1/admins/asset-count`,
        method: 'GET',
    });
};

const getFraudUsageCount = () => {
    return API({
        url: `/fraud-service/v1/admins/fraud-count`,
        method: 'GET',
    });
};

const getDashboardReport = () => {
    return API({
        url: `/account-service/v1/admins/dashboard-report`,
        method: 'GET',
    });
};

const getDashboardReportPdf = () => {
    return API({
        url: `/account-service/v1/admins/dashboard-report/pdf`,
        method: 'GET',
        responseType: 'blob',
    });
};

const getReportSchedule = () => {
    return API({
        url: `/account-service/v1/admins/report-schedule`,
        method: 'GET',
    });
};

const saveReportSchedule = (data) => {
    return API({
        url: `/account-service/v1/admins/report-schedule`,
        method: 'PUT',
        data,
    });
};

const getOsintUsageCount = () => {
    return API({
        url: `/account-service/v1/admins/osint-count`,
        method: 'GET',
    });
};

const getEmailLeakageUsageCount = () => {
    return API({
        url: `/account-service/v1/admins/mail-leakage-count`,
        method: 'GET',
    });
};

const getSocialSearcherUsageCount = () => {
    return API({
        url: `/account-service/v1/admins/social-searcher-count`,
        method: 'GET',
    });
};

const getScanPermissions = () => {
    return API({
        url: `/account-service/v1/admins/account-scan-permissions`,
        method: 'GET',
    });
};

const updateScanPermissions = (data, id) => {
    return API({
        url: `/account-service/v1/admins/${id}/account-scan-permissions`,
        method: 'PUT',
        data
    });
};

const getTakeDownRequests = (data) => {
    return API({
        url: `/fraud-service/v1/admins/fraud-process`,
        method: 'POST',
        ...data
    });
};

const updateTakeDownStatus = (params, id) => {
    return API({
        url: `/fraud-service/v1/admins/${id}/fraud-process-status`,
        method: 'PUT',
        params
    });
};

const enableUserSchedule = (accountId) => {
    return API({
        url: `/account-service/v1/admins/${accountId}/enable-schedule-task`,
        method: 'PUT',
    });
};

const disableUserSchedule = (accountId) => {
    return API({
        url: `/account-service/v1/admins/${accountId}/disable-schedule-task`,
        method: 'PUT',
    });
};

const getTickets = (data) => {
    return API({
        url: `/account-service/v1/admins/ticket`,
        method: 'POST',
        ...data
    });
};

const getUserLoginHistory = (data) => {
    return API({
        url: `/account-service/v1/admins/user-login-history`,
        method: 'POST',
        ...data
    });
};

const getModuleParameters = (data) => {
    return API({
        url: `/account-service/v1/admins/parameter-pageable`,
        method: 'POST',
        ...data
    });
};

const createModuleParameter = (data) => {
    return API({
        url: `/account-service/v1/admins/parameter`,
        method: 'POST',
        data
    });
};

const updateModuleParameter = (data, id) => {
    return API({
        url: `/account-service/v1/admins/${id}/parameter`,
        method: 'PUT',
        data
    });
};

const getQueueList = () => {
    return API({
        url: `/account-service/v1/admins/queue-size`,
        method: 'GET',
    });
};

const deleteQueue = (id) => {
    return API({
        url: `/account-service/v1/admins/clear-queue?accountId=${id}`,
        method: 'DELETE',
    });
};

const clearCache = () => {
    return API({
        url: `/account-service/v1/admins/clear-cache`,
        method: 'DELETE',
    });
};

const getEasmFormResults = (data) => {
    return API({
        url: `/account-service/v1/admins/easm-form`,
        method: 'POST',
        ...data
    });
};

const syncDataWells = () => {
    return API({
        url: `/account-service/v1/admins/sync-data-wells`,
        method: 'POST',
    });
};

const panelService = {
    getCustomerAccounts,
    updatePasswordDisplaySetting,
    getAllAccountSettings,
    deleteUserInDepartment,
    getDemoRequests,
    getAssetCount,
    getFraudUsageCount,
    getDashboardReport,
    getDashboardReportPdf,
    getReportSchedule,
    saveReportSchedule,
    getOsintUsageCount,
    getEmailLeakageUsageCount,
    getSocialSearcherUsageCount,
    getScanPermissions,
    updateScanPermissions,
    getTakeDownRequests,
    updateTakeDownStatus,
    enableUserSchedule,
    disableUserSchedule,
    getTickets,
    getUserLoginHistory,
    getModuleParameters,
    createModuleParameter,
    updateModuleParameter,
    getQueueList,
    deleteQueue,
    clearCache,
    getEasmFormResults,
    syncDataWells,
    softDeleteAccount,
    updateAccountLicense
};

export default panelService;
